// ADD NEW FLAGS HERE
// make sure value is server value!
export const EXPERIMENT_FLAGS = {
  suggestionsFeed: "SuggestionsFeed",
  weekInReviewOnProfile: "WeekInReviewOnProfile",
  disableHealthChecks: "DisableHealthChecks",
  showLogs: "ShowLogs",
  personalizedInviteLinks: "PersonalizedInviteLinks",
  supportEngineerInterviewFrontEndBug: "SupportEngineerInterviewFrontEndBug",
  focusTimeReminders: "FocusTimeReminders",
  advancedUserLogging: "AdvancedUserLogging",
  superchargedNUX: "SuperchargedNUX",
  calendarEventModal: "CalendarEventModal",
  draggableWorkingHours: "DraggableWorkingHours",
  trackLogging: "TrackLogging",
  triggerDefrag: "TriggerDefrag",
  toolTipDebugging: "ToolTipDebugging",
  slackDogfoodApp: "SlackDogfoodApp",
  inlineSchedulingSuggestions: "InlineSchedulingSuggestions",
  createEventAutopick: "CreateEventAutopick",
  heatmap: "Heatmap",
  linkSchedulerCopyTimes: "LinkSchedulerCopyTimes",
  linkScheduler: "LinkScheduler",
  checkoutPageTeamsDefault: "CheckoutPageTeamsDefault",
  onboardingFocusTimeSyncAndLunchStep: "OnboardingFocusTimeSyncAndLunchStep",
  onboardingScheduleTestEvent: "OnboardingScheduleTestEvent",
  managerSegmentedOnboarding: "ManagerSegmentedOnboarding",
  webSettings: "WebSettings",
  reduceMinSeatCountTo1: "ReduceMinSeatCountTo1",
  bulkInvitesOnboarding: "BulkInvitesOnboarding",
  reverseProTrial: "ReverseProTrial",
  dayOfWeekFlex: "DayOfWeekFlex",
} as const;

export type ExperimentNameType = typeof EXPERIMENT_FLAGS[keyof typeof EXPERIMENT_FLAGS];
export type ExperimentMappingType = {
  [key in ExperimentNameType]: boolean;
};
